<template>
    <div id="links">
      <div v-for="(menu, index) in menus" :key="index">
        <span :id="menu.key" :class="{active: menu.isActive}" @click="selectLinkMenu(index, menu.key, menu.value)">{{menu.value}}</span>
        <span class="slash" v-if="index !== (menus.length - 1)">/</span>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    // menusの配列要素は、key/value/isActive
    menus: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  methods: {
    /**
     * リンクメニューをセットする
     */
    initSelectLinkMenu() {
      if (this.menus.length > 0) {
        this.selectedLinkMenu = this.menus[0];
      }
      this.emitParent(this.menus[0].key, this.menus[0].value);
    },
    /**
     * リンクが押された時に呼ばれる。
     */
    selectLinkMenu(index, key, value) {
      console.log('index:' + index + ', key:' + key + ', value:' + value);
      // 現在選択されている要素からisActiveクラスを外す
      this.menus.filter(function(menu) {
        if (menu.isActive == true) {
          return menu.isActive = false;
        }
      });
      // 選択された要素にisActiveクラスを付与する
      this.menus[index].isActive = true;
      // 親に選択されたリンクのオブジェクトを送る
      this.emitParent(key, value);
    },
    /**
     * 親に選択されたリンクを送る
     */
    emitParent(key, value) {
      this.$emit('select-link-menu', {'key': key, 'value': value});
    }
  },
  created() {
    this.initSelectLinkMenu();
  }
}
</script>

<style scoped lang="scss">
div#links {
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
  div {
    display: inline-block;
    span.active {
      color: #EA6B66;
    }
  }
}
span.slash {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
